/* Stylesheet */

.disclaimer {
  margin: 0;
  border-radius: 5px;
  --background: var(--ion-color-dark-primary);

  .paragraph {
    padding: 21px;
    font-size: 14px;
    color: var(--ion-color-text-secondary);

    span {
      font-weight: 600;

      a {
        color: var(--ion-color-text-secondary);
      }
    }
  }
}

/* Media Queries */
@media (min-width: 992px) {
  .disclaimer {
    display: flex;
    align-items: center;
  }
}
